import Vue from 'vue';
import VueRouter from 'vue-router';
import login from '@/views/login';
import talkytimesLayout from '@/views/talkytimes';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  // 私有页面
  {
    path: '/private',
    name: 'private',
    component: () => import('../views/private'),
  },
  {
    path: '/talkytimes',
    name: 'talkytimes',
    redirect: '/talkytimes/message',
    component: talkytimesLayout,
    children: [
      // 消息
      {
        path: 'message',
        name: 'message_tt',
        component: () => import('../views/talkytimes/views/message'),
      },
      // 邮件
      {
        path: 'email',
        name: 'email_tt',
        component: () => import('../views/talkytimes/views/email'),
      },
      // 列表
      {
        path: 'list',
        name: 'list_tt',
        component: () => import('../views/talkytimes/views/list'),
      },
      // 聊天列表
      {
        path: 'chatList',
        name: 'chatList_tt',
        component: () => import('../views/talkytimes/views/chatList'),
      },
      // 批量发送
      {
        path: 'batchSending',
        name: 'batchSending_tt',
        component: () => import('../views/talkytimes/views/batchSending'),
      },
      {
        path: 'postView',
        name: 'postView_tt',
        component: () => import('../views/talkytimes/views/postView'),
      },
      {
        path: 'icebreakers',
        name: 'icebreakers_tt',
        component: () => import('../views/talkytimes/views/icebreakers'),
      },
      {
        path: 'newsFeed',
        name: 'newsFeed_tt',
        component: () => import('../views/talkytimes/views/newsFeed'),
      },
      {
        path: 'search',
        name: 'search_tt',
        component: () => import('../views/talkytimes/views/search'),
      },
      {
        path: 'wishList',
        name: 'wishList_tt',
        component: () => import('../views/talkytimes/views/wishList'),
      },
      {
        path: 'giftRecord',
        name: 'giftRecord_tt',
        component: () => import('../views/talkytimes/views/giftRecord'),
      },
      {
        path: 'masSending',
        name: 'masSending_tt',
        component: () => import('../views/talkytimes/views/masSending'),
      },
      {
        path: 'mediaLibrary',
        name: 'mediaLibrary_tt',
        component: () => import('../views/talkytimes/views/mediaLibrary'),
      },
      {
        path: 'income',
        name: 'income_tt',
        component: () => import('../views/talkytimes/views/income'),
        children: [
          {
            path: 'report/userManagement',
            name: 'income_report_userManagement',
            component: () => import('../views/talkytimes/views/income/report/userManagement'),
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 防止循环重定向
  if (from.path === to.path) {
    next();
    return;
  }
  
  // 检查是否需要认证
  const token = localStorage.getItem('Admin-Token');
  const isLoginPage = to.path === '/login';
  
  // 检查是否是退出登录操作（从有token的页面跳转到登录页）
  const isLogoutAction = token && from.path !== '/' && from.path !== '/login' && isLoginPage;
  
  // 调试信息
  console.log('路由守卫:', { 
    from: from.path, 
    to: to.path, 
    hasToken: !!token, 
    isLoginPage,
    isLogoutAction,
    tokenKey: 'Admin-Token',
    actualToken: token ? token.substring(0, 20) + '...' : 'null'
  });
  
  if (!token && !isLoginPage) {
    // 没有token且不是登录页面，重定向到登录页
    console.log('无token，重定向到登录页');
    next('/login');
    return;
  }
  
  if (token && isLoginPage && !isLogoutAction) {
    // 有token但访问登录页，允许进入登录页进行缓存清理
    console.log('有token但访问登录页，允许进入登录页进行缓存清理');
    next();
    return;
  }
  
  if (isLogoutAction) {
    // 检测到退出登录操作，允许跳转到登录页
    console.log('检测到退出登录操作，允许跳转到登录页');
    next();
    return;
  }
  
  // 如果有token且不是登录页，异步初始化WebSocket连接（不阻塞路由）
  if (token && !isLoginPage) {
    // 使用setTimeout避免阻塞路由导航
    setTimeout(() => {
      try {
        // 动态导入全局WebSocket管理器，避免循环依赖
        import('@/utils/globalWebSocketManager').then(({ default: globalWebSocketManager }) => {
          // 使用安全初始化方法，不阻塞路由导航
          if (!globalWebSocketManager.getConnectionState()) {
            console.log('路由守卫检测到WebSocket未连接，尝试安全初始化...');
            globalWebSocketManager.safeInit();
          }
        });
      } catch (error) {
        console.error('路由守卫中初始化WebSocket失败:', error);
      }
    }, 0);
  }
  
  console.log('路由守卫通过，继续导航');
  next();
});

export default router;
